import { Box, Button, Fade } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import LoginIcon from "@mui/icons-material/Login";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PublicFormButton, PublicFormCard } from "../components/common/form/PublicFormCard";
import { removeLoggedInUser } from "../modules/common/user/UserService";
import { MESSAGES } from "../modules/common/shared/messages";
import { useAuth } from "../auth/AuthContext";

export const LogoutPage = () => {
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    removeLoggedInUser();
    setUser(null);
  }, []);

  return (
    // Logout sits outside PublicLayout (no navbar), so it owns the full viewport.
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #f8fbff, #ffffff)",
      }}
    >
      <Fade in timeout={600}>
        <Box sx={{ width: "100%" }}>
          <PublicFormCard icon={<CheckCircleRoundedIcon />} tone="success" title="You've Logged Out" subtitle={MESSAGES.LOGOUT} maxWidth={420}>
            <PublicFormButton startIcon={<LoginIcon />} onClick={() => navigate("/login")}>
              Back to Login
            </PublicFormButton>
            <Button fullWidth onClick={() => navigate("/")} sx={{ mt: 1, textTransform: "none", fontWeight: 500, borderRadius: 2 }}>
              Go to Home
            </Button>
          </PublicFormCard>
        </Box>
      </Fade>
    </Box>
  );
};
